module.exports = __webpack_public_path__ + "static/media/27.78c17c2d.jpg";